import { apiClient } from "./ApiClient";

const markAffiliateLinkEntry = async (email) => {
  const { data } = await apiClient.patch(`/affiliate/link/code/${encodeURIComponent(email)}`);
  return data;
};

const createAffiliation = async () => {
  const { data } = await apiClient.post(`/affiliate/`);
  return data;
};

const getAffiliation = async () => {
  const { data } = await apiClient.get(`/affiliate/`);
  return data;
};

const deleteAffiliation = async () => {
  const { data } = await apiClient.delete(`/affiliate/`);
  return data;
};

const getAffiliationStats = async (dateStart, dateEnd) => {
  const params = new URLSearchParams();
  if (dateStart) params.append("date_start_inclusive", dateStart);
  if (dateEnd) params.append("date_end_exclusive", dateEnd);

  const { data } = await apiClient.get(`/affiliate/stats?${params.toString()}`);
  return data;
};

const getAffiliatePromocodeBatch = async ({
  skip = 0,
  limit = 10,
  sort_by = "code",
  sort_order = "asc",
  filters = {},
} = {}) => {
  const params = new URLSearchParams({
    skip: String(skip),
    limit: String(limit),
    sort_by: sort_by || "code",
    sort_order: sort_order || "asc",
  });

  const filterKeys = [
    "code",
    "type",
    "amount_min",
    "amount_max",
    "activations_left_min",
    "activations_left_max",
    "date_end_min",
    "date_end_max",
  ];

  filterKeys.forEach((key) => {
    const value = filters[key];
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });

  const { data } = await apiClient.get(`/affiliate/promocodes/batch?${params.toString()}`);
  return data;
};

const createAffiliatePromocode = async (promocode) => {
  const { data } = await apiClient.post("/affiliate/promocodes/", promocode);
  return data;
};

const updateAffiliatePromocode = async (code, promocode) => {
  const { data } = await apiClient.put(`/affiliate/promocodes/${encodeURIComponent(code)}`, promocode);
  return data;
};

const deleteAffiliatePromocode = async (code) => {
  const { data } = await apiClient.delete(`/affiliate/promocodes/${encodeURIComponent(code)}`);
  return data;
};

const activateAffiliatePromocode = async (code, dateEnd) => {
  const { data } = await apiClient.patch(`/affiliate/promocodes/activate/${encodeURIComponent(code)}`, null, {
    params: { date_end: dateEnd },
  });
  return data;
};

const disableAffiliatePromocode = async (code) => {
  const { data } = await apiClient.patch(`/affiliate/promocodes/disable/${encodeURIComponent(code)}`);
  return data;
};

const requestWalletPayout = async (walletId, amount, bankAccountNo) => {
  const { data } = await apiClient.post(
    "/wallet/payout/request",
    {},
    {
      params: {
        wallet_id: walletId,
        amount,
        bank_account_no: bankAccountNo,
      },
    },
  );
  return data;
};

const getWalletByUser = async () => {
  const { data } = await apiClient.get("/wallet/user", {
    params: {
      payout_allowed: true,
    },
  });
  return data[0] || null;
};

const getAdminAffiliateStats = async ({ skip = 0, limit = 10, dateStart, dateEnd, filters = {} } = {}) => {
  const params = new URLSearchParams({
    skip: String(skip),
    limit: String(limit),
  });

  if (dateStart) params.append("date_start_inclusive", dateStart);
  if (dateEnd) params.append("date_end_exclusive", dateEnd);

  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });

  const { data } = await apiClient.get(`/affiliate/admin?${params.toString()}`);
  return data;
};

const updateAdminAffiliate = async (affiliateId, affiliateData) => {
  const { data } = await apiClient.patch(`/affiliate/${encodeURIComponent(affiliateId)}`, affiliateData);
  return data;
};

// const getAffiliationStats = async () => {
//   return {
//     "total": {
//       "total_users_registered": 45,
//       "total_amount": 50.12,
//       "total_provision": 10.2,
//       "total_link_entries": 92
//     }
//   }
// };

export default {
  markAffiliateLinkEntry,
  createAffiliation,
  getAffiliation,
  deleteAffiliation,
  getAffiliationStats,
  getAffiliatePromocodeBatch,
  createAffiliatePromocode,
  updateAffiliatePromocode,
  deleteAffiliatePromocode,
  activateAffiliatePromocode,
  disableAffiliatePromocode,
  requestWalletPayout,
  getWalletByUser,
  getAdminAffiliateStats,
  updateAdminAffiliate,
};
